import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { Box, Button, Grid, Typography, TextField, Link } from '@mui/material';
import * as chanceApi from '../../../lib/api/chance';
import {
  chanceEstimateActive,
  chanceOrderCount,
  setChance,
  viewChance,
} from '../../../modules/chanceModule/chance';
import { viewEstimate } from '../../../modules/chanceModule/chanceEstimate';
import AskDialog from '../../../components/common/dialog/AskDialog';
import DetailTemplate from '../../../components/common/template/DetailTemplate';
import CostCalcLockContainer from '../costcalc/CostCalcLockContainer';
import CostCalcLockListContainer from '../costcalc/CostCalcLockListContainer';
import ChanceDetailForm from '../../../components/chancemng/detail/ChanceDetailForm';
import { listChanceCosts } from '../../../modules/chanceModule/chanceCosts';

const ChanceEsitmateFormContainer = ({ stepperRef }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { user, chance, estimate } = useSelector(({ chanceModule, auth }) => ({
    user: auth.user,
    chance: chanceModule.chance.chance,
    estimate: chanceModule.chanceEstimate.estimate,
  }));

  // 컴포넌트 마운트 시 서버에서 최신 chance 데이터 재조회
  useEffect(() => {
    if (chance?.prjUuid) {
      dispatch(viewChance(chance.prjUuid));
    }
  }, []);

  useEffect(() => {
    if (chance) {
      dispatch(viewEstimate(chance.prjUuid));
    }
  }, [dispatch, chance]);

  let initialValues = {
    cstNm:
      chance && chance.cstNm !== null && chance.cstNm !== undefined
        ? chance.cstNm
        : '',
    // partnerInc:
    //   chance && chance.partnerInc !== null && chance.partnerInc !== undefined
    //     ? chance.partnerInc
    //     : '',
    prjTyp:
      chance && chance.prjTyp !== null && chance.prjTyp !== undefined
        ? chance.prjTyp
        : 'N',
    // incTyp:
    //   chance && chance.incTyp !== null && chance.incTyp !== undefined
    //     ? chance.incTyp
    //     : '',
    // solutionTyp:
    //   chance && chance.solutionTyp !== null && chance.solutionTyp !== undefined
    //     ? chance.solutionTyp
    //     : '',
    // chanceTyp:
    //   chance && chance.chanceTyp !== null && chance.chanceTyp !== undefined
    //     ? chance.chanceTyp
    //     : '',
    prjImpt:
      chance && chance.prjImpt !== null && chance.prjImpt !== undefined
        ? chance.prjImpt
        : '',
    bugetYn:
      chance && chance.bugetYn !== null && chance.bugetYn !== undefined
        ? chance.bugetYn
        : '',
    partnerTyp:
      chance && chance.partnerTyp !== null && chance.partnerTyp !== undefined
        ? chance.partnerTyp
        : '',
    // chargeNm:
    //   chance && chance.chargeNm !== null && chance.chargeNm !== undefined
    //     ? chance.chargeNm
    //     : '',
    // chargeEml:
    //   chance && chance.chargeEml !== null && chance.chargeEml !== undefined
    //     ? chance.chargeEml
    //     : '',
    // chargeTel:
    //   chance && chance.chargeTel !== null && chance.chargeTel !== undefined
    //     ? chance.chargeTel
    //     : '',
    forcastTxt:
      chance && chance.forcastTxt !== null && chance.forcastTxt !== undefined
        ? chance.forcastTxt
        : '',

    productYn:
      chance && chance.productYn !== null && chance.productYn !== undefined
        ? chance.productYn
        : '',
    procurement: chance && chance.procurement === 'Y' ? true : false,
    customerUuid:
      chance && chance.customerUuid !== null && chance.customerUuid !== undefined
        ? chance.customerUuid
        : '',
    customerNm:
      chance && chance.customerNm !== null && chance.customerNm !== undefined
        ? chance.customerNm
        : '',
    vendorCmp:
      chance && chance.vendorCmp !== null && chance.vendorCmp !== undefined
        ? chance.vendorCmp
        : (chance?.customerUuid || null),
    vendorCmpNm:
      chance && chance.vendorCmpNm !== null && chance.vendorCmpNm !== undefined
        ? chance.vendorCmpNm
        : (chance?.customerNm || null),
    chargeNm:
      chance && chance.chargeNm !== null && chance.chargeNm !== undefined
        ? chance.chargeNm
        : '',
    chargeEml:
      chance && chance.chargeEml !== null && chance.chargeEml !== undefined
        ? chance.chargeEml
        : '',
    chargeTel:
      chance && chance.chargeTel !== null && chance.chargeTel !== undefined
        ? chance.chargeTel
        : '',
    expDay:
      chance && chance.expDay !== null && chance.expDay !== undefined
        ? chance.expDay
        : null,
    ordrEstDate:
        chance && chance.ordrEstDate !== null && chance.ordrEstDate !== undefined
          ? chance.ordrEstDate
          : null,
    // pmUsr:
    //   chance && chance.pmUsr !== null && chance.pmUsr !== undefined
    //     ? chance.pmUsr
    //     : '',
    // plUsr:
    //   chance && chance.plUsr !== null && chance.plUsr !== undefined
    //     ? chance.plUsr
    //     : '',
    // techUsr:
    //   chance && chance.techUsr !== null && chance.techUsr !== undefined
    //     ? chance.techUsr
    //     : '',
    crtNm:
      chance && chance.crtNm !== null && chance.crtNm !== undefined
        ? chance.crtNm
        : user?.usrNm,
    crtUsr:
      chance && chance.crtUsr !== null && chance.crtUsr !== undefined
        ? chance.crtUsr
        : user?.usrUuid,
  };

  let validationSchema = yup.object({
    cstNm: yup.string('').required('사업명을 입력하세요'),
    // partnerInc: yup.string().required('고객명을 입력하세요'),
    prjTyp: yup.string().required('프로젝트 타입을 선택하세요'),
    // incTyp: yup.string().nullable('산업체 분류를 선택하세요'),
    // solutionTyp: yup.string().nullable('아이템 구분을 선택하세요'),
    // chanceTyp: yup.string().nullable('기회유형을 선택하세요'),

    prjImpt: yup.string().nullable('프로젝트 중요도를 선택하세요'),
    bugetYn: yup.string().nullable('예산여부를 선택하세요'),
    // partnerTyp: yup.string().nullable('거래처유형을 선택하세요'),
    // chargeNm: yup.string().nullable('고객 담당자를 입력하세요'),
    // chargeEml: yup.string('').email('이메일 형식을 확인하세요').nullable(),
    // chargeTel: yup.string().nullable(),
    forcastTxt: yup.string().nullable(),

    productYn: yup.string().nullable('제품여부를 선택하세요'),
    vendorCmpNm: yup.string().nullable('매출처를 선택하세요'),
    // vendorEmp: yup.string().nullable('매출처 담당자를 선택하세요'),
    expDay: yup.date().nullable('예상 계약일을 입력하세요'),
    // pmUsr: yup.string().nullable('PM을 선택하세요'),
    // plUsr: yup.string().nullable('PL을 선택하세요'),
    // techUsr: yup.string().nullable('기술담당자를 선택하세요'),
    crtUsr: yup.string().nullable('영업담당자를 선택하세요'),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
      onSave(values);
      formik.resetForm();
      setSubmitting(false);
      // stepperRef.current?.scrollIntoView({ behavior: 'smooth' }); //저장 후 stepper로 이동함.
    },
  });

  const onSave = async (values) => {
    let dataToSubmit = {
      prjUuid: chance.prjUuid,
      // partnerInc: values.partnerInc,
      cstNm: values.cstNm.trim(),
      prjTyp: values.prjTyp,
      // incTyp: values.incTyp,
      // solutionTyp: values.solutionTyp,
      // chanceTyp: values.chanceTyp,
      prjImpt: values.prjImpt,
      bugetYn: values.bugetYn,
      partnerTyp: values.partnerTyp,
      customerUuid: values.customerUuid,
      chargeNm: values.chargeNm,
      chargeEml: values.chargeEml,
      chargeTel: values.chargeTel,
      forcastTxt: values.forcastTxt,
      procurement: values.procurement ? 'Y' : 'N',
      productYn: values.productYn,
      vendorCmp: values.vendorCmp,
      //vendorEmp: values.vendorEmp,
      expDay: values.expDay ? dayjs(values.expDay).format('YYYY-MM-DD') : null,
      ordrEstDate: values.ordrEstDate ? dayjs(values.ordrEstDate).format('YYYY-MM-DD') : null,
      // pmUsr: values.pmUsr,
      // plUsr: values.plUsr,
      // techUsr: values.techUsr,
      crtUsr: values.crtUsr, //영업 담당자
    };

    try {
      const res = await chanceApi.editChance(dataToSubmit);
      if (res.data) {
        dispatch(setChance(res.data.info));

        enqueueSnackbar(`세부 저장 성공`, {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  //원가산출 확정
  const onCostLock = async () => {
    try {
      const res = await chanceApi.completeCost(chance.prjUuid);
      if (res.data.result === 'SUCCESS') {
        dispatch(setChance(res.data.info));
        dispatch(listChanceCosts(chance.prjUuid));
        enqueueSnackbar('원가산출이 확정되었습니다', { variant: 'success' });
      } else {
        const message =
          res.data.result === 'NOT_VALID_COST_INFO'
            ? '원가산출을 확정할 수 없습니다(마이너스 원가)'
            : '원가산출을 확정할 수 없습니다';
        enqueueSnackbar(message, { variant: 'error' });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, { variant: 'error' });
    }
  };

  //원가산출 해제
  const [unLockVisible, setUnlockVisible] = useState(false);
  const onUnLockCancle = () => {
    setUnlockVisible(false);
  };
  const onUnLockConfirm = () => {
    setUnlockVisible(false);
    onCostUnLock();
  };
  const onCostUnLock = async () => {
    try {
      const res = await chanceApi.unDoCost(chance.prjUuid);

      if (res.data.info) {
        dispatch(setChance(res.data.info));
        dispatch(chanceEstimateActive(chance.prjUuid));
        dispatch(chanceOrderCount(chance.prjUuid));

        navigate(`/chancemng/${chance.prjUuid}/2/1`);

        enqueueSnackbar('원가산출이 해제되었습니다.', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
      noValidate
      autoComplete="off"
      onSubmit={formik.handleSubmit}
    >
      {/* <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          my: 2,
        }}
      >
        <Button
          variant="contained"
          color="warning"
          onClick={() => setUnlockVisible(true)}
        >
          원가산출 해제
        </Button>
        <Button type="submit" variant="outlined" disabled={formik.isSubmitting}>
          저장
        </Button>
      </Box> */}
      {chance?.useYn === 'N' && (
        <DetailTemplate title="포캐스팅 실패 사유">
          <Box sx={{ whiteSpace: 'pre-line' }}>{chance?.failTxt}</Box>
        </DetailTemplate>
      )}
      <Box>
        {/* <ChanceEsitmateForm
          formik={formik}
          chance={chance}
          estimate={estimate}
        /> */}
        <ChanceDetailForm formik={formik} chance={chance} />
      </Box>
      {chance?.costYn === 'Y' ? (
        <Box sx={{ my: { xs: 1, md: 2 } }}>
          <CostCalcLockContainer chance={chance} />
        </Box>
      ) : (
        <DetailTemplate title="원가 산출 내역">
          <Box>
            <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="body2" color="error">
                원가산출이 확정되지 않았습니다. 아래 내역을 확인 후 확정하세요.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={onCostLock}
              >
                원가산출 확정
              </Button>
            </Box>
            <CostCalcLockListContainer />
          </Box>
        </DetailTemplate>
      )}
      <DetailTemplate title="견적">
        {estimate ? (
          <>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  견적 번호
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" component="div">
                  {estimate?.qteNo}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  견적일자
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" component="div">
                  {estimate?.qteRegDt ? estimate?.qteRegDt : estimate?.crtDt}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  견적 유효일자
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" component="div">
                  {estimate?.qteValidDt}
                </Typography>
              </Grid>
              <Grid item xs={4} />
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  담당자명
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" component="div">
                  {estimate?.qteUsrNm}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  담당자 연락처
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" component="div">
                  {estimate?.qteUsrTel}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  담당자 이메일
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" component="div">
                  {estimate?.qteUsrEml}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  총 견적 금액
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" component="div">
                  ₩{' '}
                  {estimate?.qtePrice
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  유지보수기간
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" component="div">
                  {estimate?.mntTor} 개월
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  납품 장소
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="body2" component="div">
                  {estimate?.destPlace}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  발행 조건
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="body2" component="div">
                  {estimate?.qteCondt}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  결제 조건
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="body2" component="div">
                  {estimate?.payCond}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  견적서 설명 1
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="body2" component="div">
                  {estimate?.qteDesc1}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  견적서 설명 2
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="body2" component="div">
                  {estimate?.qteDesc2}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  견적서 설명 3
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="body2" component="div">
                  {estimate?.qteDesc3}
                </Typography>
              </Grid>
            </Grid>
          </>
        ) : (
          <Box>
            <Typography variant="subtitle2" component="div">
              현재 활성화된 견적서가 없습니다.
            </Typography>
          </Box>
        )}
      </DetailTemplate>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          my: 2,
        }}
      >
        {chance?.costYn === 'Y' && (
          <Button
            variant="contained"
            color="warning"
            onClick={() => setUnlockVisible(true)}
          >
            원가산출 해제
          </Button>
        )}
        {chance?.costYn !== 'Y' && <Box />}
        <Button type="submit" variant="outlined" disabled={formik.isSubmitting}>
          저장
        </Button>
      </Box>

      <AskDialog
        visible={unLockVisible}
        title="프로젝트 원가 산출 해제"
        description={`원가산출을 해제하시겠습니까?\r\n작업된(견적서 / 수주품의서 ) 등의 사항을 다시 작성해야됩니다.`}
        confirmText="해제"
        onConfirm={onUnLockConfirm}
        onCancle={onUnLockCancle}
      />
    </Box>
  );
};

export default ChanceEsitmateFormContainer;
